import React, { useState, useEffect } from 'react';
import { Box, Grid } from '@mui/material';
import ReportTile from './components/ReportTile';
import WeeklyView from './components/WeeklyView';
import MonthlyView from './components/MonthlyView';
import YearlyView from './components/YearlyView';
import WeeklyViewAll from './components/WeeklyViewAll';
import MonthlyViewAll from './components/MonthlyViewAll';
import YearlyViewAll from './components/YearlyViewAll';
import WeeklyProjectsViewAll from './components/WeeklyProjectsViewAll';
import MonthlyProjectsViewAll from './components/MonthlyProjectsViewAll';
import YearlyProjectsViewAll from './components/YearlyProjectsViewAll';
import CustomSearch from './components/CustomSearch';
import PTOView from './components/PTOView';
import QuickbooksReport from './components/QuickbooksReport';
import { useAuth } from '../../context/AuthContext';

const Reporting = () => {
  const { user } = useAuth();
  const [activeView, setActiveView] = useState(null);

  useEffect(() => {
  }, [user]);

  const isAdminOrTeamLeadOrAccountant = user?.role === 'admin' || user?.role === 'team_lead' || user?.role === 'accountant';

  const reports = [
    // First Row: Individual User Views
    {
      id: 'weekly',
      title: 'Weekly View For One User',
      onClick: () => setActiveView('weekly')
    },
    {
      id: 'monthly',
      title: 'Monthly View For One User',
      onClick: () => setActiveView('monthly')
    },
    {
      id: 'yearly',
      title: 'Yearly View For One User',
      onClick: () => setActiveView('yearly')
    },
    // Admin/Team Lead/Accountant reports
    ...(isAdminOrTeamLeadOrAccountant ? [
      // Second Row: All Users Views
      {
        id: 'weekly-all',
        title: 'Weekly View For All Users',
        onClick: () => setActiveView('weekly-all')
      },
      {
        id: 'monthly-all',
        title: 'Monthly View For All Users',
        onClick: () => setActiveView('monthly-all')
      },
      {
        id: 'yearly-all',
        title: 'Yearly View For All Users',
        onClick: () => setActiveView('yearly-all')
      },
      // Third Row: All Projects Views
      {
        id: 'weekly-projects',
        title: 'Weekly View For All Projects',
        onClick: () => setActiveView('weekly-projects')
      },
      {
        id: 'monthly-projects',
        title: 'Monthly View For All Projects',
        onClick: () => setActiveView('monthly-projects')
      },
      {
        id: 'yearly-projects',
        title: 'Yearly View For All Projects',
        onClick: () => setActiveView('yearly-projects')
      },
      // Fourth Row: Additional Reports
      {
        id: 'custom-search',
        title: 'Custom Search',
        onClick: () => setActiveView('custom-search')
      },
      {
        id: 'pto-view',
        title: 'PTO Report',
        onClick: () => setActiveView('pto-view')
      },
      {
        id: 'quickbooks-report',
        title: 'Quickbooks Report',
        onClick: () => setActiveView('quickbooks-report')
      }
    ] : [
      // For regular users, Custom Search comes after the individual user views
      {
        id: 'custom-search',
        title: 'Custom Search',
        onClick: () => setActiveView('custom-search')
      }
    ])
  ];

  const handleBackToGrid = () => {
    setActiveView(null);
  };

  // Render active view or grid
  if (activeView === 'weekly') {
    return <WeeklyView onBack={handleBackToGrid} />;
  }

  if (activeView === 'monthly') {
    return <MonthlyView onBack={handleBackToGrid} />;
  }

  if (activeView === 'yearly') {
    return <YearlyView onBack={handleBackToGrid} />;
  }

  if (activeView === 'weekly-all') {
    return <WeeklyViewAll onBack={handleBackToGrid} />;
  }

  if (activeView === 'monthly-all') {
    return <MonthlyViewAll onBack={handleBackToGrid} />;
  }

  if (activeView === 'yearly-all') {
    return <YearlyViewAll onBack={handleBackToGrid} />;
  }

  if (activeView === 'weekly-projects') {
    return <WeeklyProjectsViewAll onBack={handleBackToGrid} />;
  }

  if (activeView === 'monthly-projects') {
    return <MonthlyProjectsViewAll onBack={handleBackToGrid} />;
  }

  if (activeView === 'yearly-projects') {
    return <YearlyProjectsViewAll onBack={handleBackToGrid} />;
  }

  if (activeView === 'custom-search') {
    return <CustomSearch onBack={handleBackToGrid} />;
  }

  if (activeView === 'pto-view') {
    return <PTOView onBack={handleBackToGrid} />;
  }

  if (activeView === 'quickbooks-report') {
    return <QuickbooksReport onBack={handleBackToGrid} />;
  }

  return (
    <Box sx={{ 
      p: 3,
      '@media (max-width:600px)': {
        paddingBottom: '88px', // 72px bottom nav height + 16px extra margin
      }
    }}>
      <Grid container spacing={3}>
        {reports.map((report) => (
          <Grid item xs={12} sm={6} md={4} key={report.id}>
            <ReportTile
              title={report.title}
              onClick={report.onClick}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Reporting;
